import {Directive, HostBinding, Input} from '@angular/core';


@Directive({
    selector: '[acDisable]',
})
export class AcDisableDirective {
    @Input() @HostBinding('class.ac-disabled') acDisable = false;
}
